import { useTranslation } from 'react-i18next';
import { Button, Icon, Text } from 'ui';

type P = {
  count: number;
  onShowComments?: () => void;
};

const CommentCount = ({ count, onShowComments }: P) => {
  const { t } = useTranslation();
  return (
    <Button icon={<Icon icon="chat-3-line" size="extra-small" />} onClick={onShowComments} type="text">
      <Text size="small" type="secondary">
        {t('commentsCount', { count })}
      </Text>
    </Button>
  );
};

export default CommentCount;
